import React from 'react';
import ReactDOM from 'react-dom';

import NucleusCore from './Core';

ReactDOM.render(<NucleusCore />, document.getElementById('root'));
